import React, { createContext, useContext } from 'react';
import { useAuth } from '../auth/useAuth';
import { useTracking } from './useTracking';

const TrackingContext = createContext(null);

export function TrackingProvider({ children }) {
  const { user } = useAuth();
  const tracking = useTracking(user);
  return (
    <TrackingContext.Provider value={tracking}>
      {children}
    </TrackingContext.Provider>
  );
}

export function useTrack() {
  const context = useContext(TrackingContext);
  return context || {
    trackEvent: () => {},
    flush: async () => {},
    endSession: async () => {},
  };
}
